import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLink = (pathname, to) => {
  if (to === '/admin') {
    return pathname === '/admin' || pathname === '/admin/';
  }
  return pathname === to || pathname.startsWith(`${to}/`);
};

const SidebarLink = ({ to, children }) => {
  const { pathname } = useLocation();
  const active = navLink(pathname, to);

  return (
    <li className={`nav-item${active ? ' active' : ''}`}>
      <Link className="nav-link" to={to}>
        {children}
      </Link>
    </li>
  );
};

const AdminSidebar = () => {
  const { pathname } = useLocation();
  const productActive =
    pathname.startsWith('/admin/product') ||
    pathname.startsWith('/admin/bundleproduct') ||
    pathname.startsWith('/admin/productattribute') ||
    pathname.startsWith('/admin/productreview');

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item nav-category">Main</li>
        <SidebarLink to="/admin">
          <span className="icon-bg"><i className="mdi mdi-cube menu-icon"></i></span>
          <span className="menu-title">Dashboard</span>
        </SidebarLink>
        <SidebarLink to="/admin/category">
          <span className="icon-bg"><i className="mdi mdi-shape menu-icon"></i></span>
          <span className="menu-title">Category</span>
        </SidebarLink>
        <SidebarLink to="/admin/banner">
          <span className="icon-bg"><i className="mdi mdi-image menu-icon"></i></span>
          <span className="menu-title">Banner</span>
        </SidebarLink>
        <SidebarLink to="/admin/addbanner">
          <span className="icon-bg"><i className="mdi mdi-image-plus menu-icon"></i></span>
          <span className="menu-title">Add Banner</span>
        </SidebarLink>

        <li className="nav-item nav-category">Product</li>
        <li className={`nav-item${productActive ? ' active' : ''}`}>
          <a
            className="nav-link"
            data-bs-toggle="collapse"
            href="#product-menu"
            aria-expanded={productActive ? 'true' : 'false'}
            aria-controls="product-menu"
            style={{ outline: 'none', boxShadow: 'none' }}
          >
            <span className="icon-bg"><i className="mdi mdi-package-variant menu-icon"></i></span>
            <span className="menu-title">Product</span>
            <i className="menu-arrow"></i>
          </a>
          <div className={`collapse${productActive ? ' show' : ''}`} id="product-menu">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link className="nav-link" to="/admin/product">Products</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/admin/bundleproduct">Bundle Products</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/admin/productattribute">Product Attribute</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/admin/productreview">Product Reviews</Link>
              </li>
            </ul>
          </div>
        </li>

        <li className="nav-item nav-category">Settings</li>
        <SidebarLink to="/admin/setting">
          <span className="icon-bg"><i className="mdi mdi-cog menu-icon"></i></span>
          <span className="menu-title">Settings</span>
        </SidebarLink>

        <li className="nav-item nav-category">Orders</li>
        <SidebarLink to="/admin/cart">
          <span className="icon-bg"><i className="mdi mdi-cart menu-icon"></i></span>
          <span className="menu-title">Carts</span>
        </SidebarLink>
        <SidebarLink to="/admin/order">
          <span className="icon-bg"><i className="mdi mdi-clipboard-list menu-icon"></i></span>
          <span className="menu-title">Orders</span>
        </SidebarLink>

        <li className="nav-item nav-category">User Management</li>
        <SidebarLink to="/admin/user">
          <span className="icon-bg"><i className="mdi mdi-account-multiple menu-icon"></i></span>
          <span className="menu-title">Users</span>
        </SidebarLink>
      </ul>
    </nav>
  );
};

export default AdminSidebar;
